<script setup lang="ts">
import {ref, computed} from 'vue';

import {
  MagicModel3DRenderer,
  MagicModel3D,
} from '@teemill/modules/magic-models';

const props = defineProps<{
  modelData: MagicModel3D[];
  designFileUrl: string;
  activeColorName?: string;
}>();

const emit = defineEmits(['enter', 'leave', 'rendered']);

const activeModelIndex = ref(0);

const activeModel = computed(() => {
  return props.modelData[activeModelIndex.value];
});
</script>

<template>
  <tml-new-popup
    name="3d-preview"
    layout="standard"
    size="normal"
    height="auto"
    title="Preview"
    @enter="emit('enter')"
    @before-leave="emit('leave')"
  >
    <template #content>
      <div class="inline-block m-auto">
        <magic-model-3-d-renderer
          v-if="activeModel && designFileUrl"
          :model-resource-url="activeModel.model.url.replace(/^\/\//, '/')"
          :environment-map-url="activeModel.environmentMap.url"
          :environment-map-intensity="activeModel.environmentMap.intensity"
          :design-area-identifier="activeModel.designAreaIdentifier"
          :design-file-url="designFileUrl"
          :camera-position="{
            x: activeModel.cameraPosition.x,
            y: activeModel.cameraPosition.y,
            z: activeModel.cameraPosition.z,
          }"
          :width="1000"
          :height="1000"
          :lights="[]"
          :active-color-name="activeColorName"
          @rendered="canvas => emit('rendered', canvas)"
        />
      </div>
    </template>
    <template #footer>
      <slot name="footer"> </slot>
    </template>
  </tml-new-popup>
</template>
